
angular.module('mtic', [
	// Dependencies
	'ngCookies',
	'firebase',
	'ng-fastclick',
	'ngSanitize',
  'ngAnimate',
  '720kb.tooltips',
	// Main module
	'mtic.components.main'
	]);

/**
 * Configure Timezone
 * @type {[type]}
 */
var currentTimesZone = moment.tz.guess();//Set this to `Europe/Luxembourg` for lux time
moment.tz.setDefault(currentTimesZone)


// if (window.location.origin === 'https://mathematic.org'){
//   window.location.href = 'https://mathematic.lu/app2'
// }
